import {Component, OnInit} from '@angular/core';
import {AlertService} from "../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {CategoryService} from "../services/category.service";
import {MatDialog} from "@angular/material/dialog";
import {CategoryDialogComponent} from "../category/dialog/categoryDialog.component";
import {ResourceService} from "../services/resource.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {ResourceType} from "./model/resourceType";
import {Resource} from "../models/resource";

@Component({
    templateUrl: './resourceForm.component.html',
    styleUrls: ['./resourceForm.component.scss']
})

export class ResourceFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    categories: any[];
    vatRates: any[];
    units: any[];
    dialogRef: any;
    resourceTypes: ResourceType[] = [];
    resource: Resource;
    processing: boolean = false;

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private categoryService: CategoryService,
        private resourceService: ResourceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Resources');
    }

    ngOnInit() {
        this.resourceTypes = this.route.snapshot.data.resourceTypes.items;
        this.resource = this.route.snapshot.data.resource;

        this.categoryService.getAllByType('resource').subscribe((res: any[]) => {
            this.categories = res;
        }, error => {
            this.alertService.error(error);
        });

        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            description: [''],
            serialNumber: [''],
            deviceId: [''],
            category: [''],
            enableCalendar: [''],
            enableAutomaticPayments: [''],
            alwaysActiveInCalendar: [''],
            isActive: [''],
            isRegistered: [''],
            calendarPriority: [''],
            reservationTime: [''],
            requiredCredits: [0],
            isFiscalPrinter: [false],
            type: ['']
        });

        if (!this.isAddMode) {
            this.f.name.setValue(this.resource.name);
            this.f.description.setValue(this.resource.description);
            this.f.serialNumber.setValue(this.resource.serialNumber);
            this.f.deviceId.setValue(this.resource.deviceId);
            if (this.resource.category) {
                this.f.category.setValue(this.resource.category.id);
            }
            this.f.enableCalendar.setValue(this.resource.enableCalendar);
            this.f.enableAutomaticPayments.setValue(this.resource.enableAutomaticPayments);
            this.f.alwaysActiveInCalendar.setValue(this.resource.alwaysActiveInCalendar);
            this.f.isActive.setValue(this.resource.isActive);
            this.f.isRegistered.setValue(this.resource.isRegistered);
            this.f.calendarPriority.setValue(this.resource.calendarPriority);
            this.f.reservationTime.setValue(this.resource.reservationTime);
            this.f.isFiscalPrinter.setValue(this.resource.isFiscalPrinter);
            this.f.requiredCredits.setValue(this.resource.requiredCredits);
            this.f.type.setValue(this.resource.type);
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createResource();
        } else {
            this.updateResource();
        }
    }

    public addCategory() {
        this.dialogRef = this._matDialog.open(CategoryDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'new',
                categories: this.categories,
            }
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if ( !response )
                {
                    return;
                }

                let category = response.getRawValue();
                category.type = 'resource';

                this.categoryService.create(category)
                    .pipe(first())
                    .subscribe(
                        data => {
                            this.alertService.success('Category added successfully', { keepAfterRouteChange: true });
                        },
                        error => {
                            this.alertService.error(error);
                            this.loading = false;
                        });

            }, (err) => {
                console.log(err);
            });
    }


    private createResource() {
        this.processing = true;
        this.resourceService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Product added successfully', { keepAfterRouteChange: true });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.processing = false;
                });
    }

    private updateResource() {
        this.processing = true;
        this.resourceService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful', { keepAfterRouteChange: true });
                    this.processing = false;
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.processing = false;
                });
    }
}
